// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import { Constants, RespondentEmailValidationModel, RespondentModel } from '../../../models';
import { RespondentsBaseService } from './respondents-base.service';
import { ParticipantGroupsBaseService } from './participant-groups-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class RespondentsMockService extends RespondentsBaseService {
  override clearValidateRespondentEmailAddressV2(): void {
    throw new Error('Method not implemented.');
  }
  override delete(respondent: RespondentModel): void {
    throw new Error('Method not implemented.');
  }
  override validateRespondentEmailAddressV2(model: RespondentEmailValidationModel): void {
    throw new Error('Method not implemented.');
  }

  constructor(groupsService: ParticipantGroupsBaseService) {
    super(groupsService);
  }

  checkForRespondentEmailBounce(model: RespondentEmailValidationModel): void {
  }

  validateRespondentEmailAddress(model: RespondentEmailValidationModel): void {
    const isValidAddOrUpdateRequest = this.groupsService.validateAddOrUpdateLocally(model);
    if (!isValidAddOrUpdateRequest) {
      this.groupsService.respondentValidated(model);
      return;
    }

    const randmomMilliseconds = (Math.random() * 1000) + 300;
    of(model)
      .pipe(
        delay(randmomMilliseconds)
      )
      .subscribe(m => {
        if (m.emailAddress === 'valid@email.com') {
          m.isValid = true;
          m.firstName = 'frikkie';
          m.lastName = 'van Tonder';
        } else {
          m.isValid = false;
          m.errorMessage = 'The respondent is not valid!';
        }

        this.groupsService.respondentValidated(model);
        if (m.isValid) {
          const theRespondent = this.groupsService.getRespondentFromGroup(m.groupId, m.respondentGroupIndex);
          if (theRespondent) {
            this.addOrUpdate(theRespondent);
          }
        }
      });
  }

  addOrUpdate(model: RespondentModel): void {
    const validationModel = {
      emailAddress: model.emailAddress,
      groupId: model.groupId,
      respondentGroupIndex: model.groupIndex
    } as RespondentEmailValidationModel;
    const isValidAddOrUpdateRequest = this.groupsService.validateAddOrUpdateLocally(validationModel);

    if (!isValidAddOrUpdateRequest) {
      model.isValid = false;
      model.errorMessage = validationModel.errorMessage;
      this.groupsService.refreshRespondent(model);
      return;
    }

    const randmomMilliseconds = (Math.random() * 1000) + 300;
    of (model)
      .pipe(
        delay(randmomMilliseconds)
      )
      .subscribe(m => {
        if (m.id) { // update
        } else {  // add
          m.id = Math.floor(Math.random() * 1000000000 + 1).toString();
        }
        m.isSet = true;
        this.groupsService.respondentUpdated(m);
      });
  }

  getPreviousRespondents(pageSize?: number) {
    if (!pageSize) {
      pageSize =  Constants.DEFAULT_PAGE_SIZE;
    }
    this._previousRespondents$.next([] as RespondentModel[]);
  }
}
